import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qzzerk93mj: FaireBrandEntity = {
  token: "b_qzzerk93mj",
  type: "brand",
  name: "Productseeker",
  avatarUrl:
    "https://cdn.faire.com/fastly/24490bf445c0569f3aa4929935b62438358d745741ae90ee0b52c923f2be0dd4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/049c352538459950702b0cc3d716ed872ce2508a43832ee5f22e6b0272a316f2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/24490bf445c0569f3aa4929935b62438358d745741ae90ee0b52c923f2be0dd4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/049c352538459950702b0cc3d716ed872ce2508a43832ee5f22e6b0272a316f2.jpeg",
  location: "New York , NY, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 287,
  isTopShop: true,
  isInsider: true,
  description:
    "Located in New York, Productseeker is a garment manufacturer and sourcing company devoted to bringing women's accessible luxury fashion products to you. We produce quality pieces that not only look amazing, but are comfortable to wear throughout the day.\n\nWe provide drop shipping and bulk production services that fit all sizes of business with a competitive price in setting up a new brand or developing your current one, our goal is to establish a win-win cooperation with you and grow the business together.   ",
  meta: {
    source: "api",
    importedAt: "2026-08-18T17:20:33.382Z",
    importedBy: "entity-db-cli",
  },
};
